const Landing = () => {
    return (
        <div className="center-align">
            <h1>Emailie!</h1>
            Collect feedback from your users
        </div>
    );
};

export default Landing;